module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-wrapper"
  }, [_c('h1'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v("文件内容无法识别，可能已损坏。请重新保存再上传。")]), _vm._v(" "), _c('router-link', {
    staticClass: "el-button el-button--primary el-button--large",
    attrs: {
      "to": {
        name: 'project_upload',
        params: {
          id: _vm.project.id
        }
      }
    }
  }, [_vm._v("\n    重新上传\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-wrapper"
  }, [_c('div', {
    staticClass: "mock-circle"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("出错啦")])]), _vm._v(" "), _c('div', {
    staticClass: "background-image img"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5abbd173"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/show/error/index.vue
// module id = 921
// module chunks = 3